module.exports = __webpack_public_path__ + "img/ball_9_green.18288773.png";